import label from "@/lang/StaticLabels.js";

// PCRM Router  -----------------------------------------------
let routeItems = {
  path: "PCRM",
  name: "PCRM",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  // با کلیک روی ماژول، داشبورد همان ماژول پیش‌فرض باز می‌شود
  redirect: { name: "PCRMDashboard" },
  children: [
    {
      path: "dashboard",
      name: "PCRMDashboard",
      meta: {
        label: label.page.dashboard + " " + label.modules.pcrm,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pcrm/Dashboard"),
    },
    // Base Information  -----------------------------------------------
    {
      path: "companyInfo",
      name: "PCRMCompanyInfo",
      meta: {
        label: label.page.companyInfo,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pcrm/base/companyInfo"),
    },
    {
      path: "personClub",
      name: "PCRMPersonClub",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "personClub/list",
      children: [
        {
          path: "list",
          name: "PCRMPersonClubList",
          component: () => import("@/views/modules/pcrm/base/personClub"),
          meta: {
            label: label.page.customerManagement,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PCRMAddPersonClub",
          component: () => import("@/views/modules/pcrm/base/personClub/Add"),
          meta: {
            label: label.page.addPersonClub,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PCRMEditPersonClub",
          component: () => import("@/views/modules/pcrm/base/personClub/Edit"),
          meta: {
            label: label.page.editPersonClub,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "personClubGrouping",
      name: "PCRMPersonClubGrouping",
      meta: {
        label: label.page.customerGrouping,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pcrm/base/personClub/Grouping"),
    },
    {
      path: "personClubGrade",
      name: "PCRMPersonClubGrade",
      meta: {
        label: label.page.customerGrade,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pcrm/base/personClub/Grade"),
    },
    {
      path: "salesChannels",
      name: "PCRMSalesChannels",
      meta: {
        label: label.page.salesChannelsTypes,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pcrm/base/salesChannels"),
    },
    {
      path: "discount",
      name: "PCRMDiscount",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "discount/list",
      children: [
        {
          path: "list",
          name: "PCRMDiscountList",
          component: () => import("@/views/modules/pcrm/base/discount"),
          meta: {
            label: label.page.discountCodes,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PCRMAddDiscount",
          component: () => import("@/views/modules/pcrm/base/discount/Add"),
          meta: {
            label: label.page.addDiscountCode,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PCRMEditDiscount",
          component: () => import("@/views/modules/pcrm/base/discount/Edit"),
          meta: {
            label: label.page.editDiscountCode,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "introducedType",
      name: "PCRMIntroducedType",
      meta: {
        label: label.page.introducedType,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pcrm/base/introducedType"),
    },
    {
      path: "personClubTagsTypes",
      name: "PCRMPersonClubTagsTypes",
      meta: {
        label: label.page.customerTagsTypes,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pcrm/base/personClub/Tags"),
    },
    {
      path: "feedBackType",
      name: "PCRMFeedbackType",
      meta: {
        label: label.page.feedBackType,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pcrm/base/feedBackType"),
    },
    {
      path: "feedBackQuestionOption",
      name: "PCRMFeedbackQuestionOption",
      meta: {
        label: label.page.feedBackQuestionOption,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pcrm/base/feedBackQuestionOption"),
    },
    {
      path: "serviceCenters",
      name: "PCRMServiceCenter",
      meta: {
        label: label.page.serviceCenters,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pcrm/base/serviceCenters"),
    },
    {
      path: "occasionTypes",
      name: "PCRMOccasionTypes",
      meta: {
        label: label.page.occasionTypes,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pcrm/base/occasionType"),
    },
    {
      path: "process",
      name: "PCRMProcess",
      component: {
        render(c) {
          return c("router-view");
        },
        component: () => import("@/views/modules/pcrm/base/occasionType"),
      },
      redirect: "process/list",
      children: [
        {
          path: "list",
          name: "PCRMProcessList",
          component: () => import("@/views/modules/pcrm/base/process"),
          meta: {
            label: label.page.autoProcesses,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PCRMAddProcess",
          component: () => import("@/views/modules/pcrm/base/process/Add"),
          meta: {
            label: label.page.addAutoProcess,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PCRMEditProcess",
          component: () => import("@/views/modules/pcrm/base/process/Edit"),
          meta: {
            label: label.page.editAutoProcess,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "messageSetting",
      name: "PCRMMessageSetting",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "messageSetting/list",
      children: [
        {
          path: "list",
          name: "PCRMCongratulationsMsgSettings",
          component: () =>
            import(
              "@/views/modules/pcrm/base/settings/congratulationsMessage/index"
            ),
          meta: {
            label: label.page.congratulationsMessageSettings,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PCRMAddCongratulationsMsgSettings",
          component: () =>
            import(
              "@/views/modules/pcrm/base/settings/congratulationsMessage/Add"
            ),
          meta: {
            label: label.page.addCongratulationsMessageSettings,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PCRMEditCongratulationsMsgSettings",
          component: () =>
            import(
              "@/views/modules/pcrm/base/settings/congratulationsMessage/Edit"
            ),
          meta: {
            label: label.page.editCongratulationsMessageSettings,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "systemSetting",
      name: "PCRMSystemSetting",
      meta: {
        label: label.page.systemSetting,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pcrm/base/settings/systemSetting"),
    },
    {
      path: "reminderSettings",
      name: "PCRMReminderSettings",
      meta: {
        label: label.page.deadlineReminderSettings,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pcrm/base/settings/Reminder.vue"),
    },
    // {
    //   path: "congratulationsMessage",
    //   name: "PCRMCongratulationsMsgSettings",
    //   meta: {
    //     label: label.page.congratulationsMessageSettings,
    //     requiresAuth: true,
    //   },
    //   component: () =>
    //     import("@/views/modules/pcrm/base/settings/congratulationsMessage"),
    // },
    {
      path: "profileSettings",
      name: "PCRMProfileSettings",
      meta: {
        label: label.page.profileCompletionSettings,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pcrm/base/settings/ProfileSetting"),
    },
    {
      path: "manageUsers",
      name: "PCRMManageUsers",
      meta: {
        label: label.page.manageUsers,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pcrm/base/manageUsers"),
    },
    // Operation -----------------------------------------------
    {
      path: "order",
      name: "PCRMOrder",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "order/list",
      children: [
        {
          path: "list",
          name: "PCRMPOrderList",
          component: () => import("@/views/modules/pcrm/operation/orders"),
          meta: {
            label: label.page.orders,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PCRMAddOrder",
          component: () => import("@/views/modules/pcrm/operation/orders/Add"),
          meta: {
            label: label.page.addOrder,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PCRMEditOrder",
          component: () => import("@/views/modules/pcrm/operation/orders/Edit"),
          meta: {
            label: label.page.editOrder,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "deliveryMethod",
      name: "PCRMDeliveryMethod",
      meta: {
        label: label.page.deliveryMethod,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pcrm/base/deliveryMethod"),
    },
    {
      path: "paymentMethod",
      name: "PCRMPaymentMethod",
      meta: {
        label: label.page.paymentMethod,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pcrm/base/paymentMethod"),
    },
    {
      path: "feedBack",
      name: "PCRMFeedback",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "feedBack/list",
      children: [
        {
          path: "list",
          name: "PCRMFeedbackList",
          meta: {
            label: label.page.feedBack,
            requiresAuth: true,
          },
          component: () =>
            import("@/views/modules/pcrm/operation/feedBack/List"),
        },

        {
          path: "question/add/:id",
          name: "PCRMAddFeedBackQuestions",
          meta: {
            label: label.page.feedBackManagement,
            requiresAuth: true,
          },
          component: () =>
            import("@/views/modules/pcrm/operation/feedBack/Questions"),
        },
      ],
    },
    // Reports -----------------------------------------------
    {
      path: "reports",
      name: "PCRMReports",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "reports/someVouchers",
      children: [
        {
          path: "customerCreditVoucher",
          name: "PCRMCustomerCreditVoucher",
          component: () =>
            import("@/views/modules/pcrm/reports/customerCreditVoucher"),
          meta: {
            label: label.page.customerCreditVoucher,
            requiresAuth: true,
          },
        },
        {
          path: "customerScoreVoucher",
          name: "PCRMCustomerScoreVoucher",
          component: () =>
            import("@/views/modules/pcrm/reports/customerScoreVoucher"),
          meta: {
            label: label.page.customerScoreVoucher,
            requiresAuth: true,
          },
        },
        {
          path: "customerScoreSummery",
          name: "PCRMCustomerScoreSummery",
          component: () =>
            import("@/views/modules/pcrm/reports/customerScoreSummery"),
          meta: {
            label: label.page.scoreSummery,
            requiresAuth: true,
          },
        },
        {
          path: "comprehensiveCustomerReport",
          name: "PCRMComprehensiveCustomer",
          component: () =>
            import("@/views/modules/pcrm/reports/comprehensiveCustomer"),
          meta: {
            label: label.page.comprehensiveCustomerReport,
            requiresAuth: true,
          },
        },
        {
          path: "userPerformance",
          name: "PCRMMostCustomerRegistrations",
          component: () =>
            import("@/views/modules/pcrm/reports/mostCustomerRegistrations"),
          meta: {
            label: label.page.userPerformanceReport,
            requiresAuth: true,
          },
        },
        {
          path: "feedbackHistories",
          name: "PCRMFeedbackHistories",
          component: () =>
            import("@/views/modules/pcrm/reports/feedback/History"),
          meta: {
            label: label.page.feedbackHistories,
            requiresAuth: true,
          },
        },
        {
          path: "feedbackByQuestion",
          name: "PCRMFeedBackByQuestion",
          component: () =>
            import("@/views/modules/pcrm/reports/feedback/FeedBackByQuestion"),
          meta: {
            label: label.page.feedBackByQuestion,
            requiresAuth: true,
          },
        },
        {
          path: "feedbackAnswer/:id",
          name: "PCRMFeedbackAnswerSheet",
          component: () =>
            import("@/views/modules/pcrm/reports/feedback/AnswerSheet"),
          meta: {
            label: label.page.answerSheet,
            requiresAuth: true,
          },
        },
        {
          path: "feedbackReport",
          name: "PCRMFeedbackReport",
          component: () => import("@/views/modules/pcrm/reports/feedback"),
          meta: {
            label: label.page.feedbackReport,
            requiresAuth: true,
          },
        },
        {
          path: "feedbackHistoryDetails/:id",
          name: "PCRMFeedbackHistoryDetails",
          component: () =>
            import("@/views/modules/pcrm/reports/feedback/HistoryDetails"),
          meta: {
            label: label.page.feedbackHistoryDetails,
            requiresAuth: true,
          },
        },
        {
          path: "feedbackAllHistory",
          name: "PCRMFeedbackHistoryAllDetails",
          component: () =>
            import("@/views/modules/pcrm/reports/feedback/HistoryAllDetails"),
          meta: {
            label: label.page.historyAllDetails,
            requiresAuth: true,
          },
        },
        {
          path: "purchaseAndFeedbackHistories/:id",
          name: "PCRMPurchaseAndFeedbackHistories",
          component: () =>
            import(
              "@/views/modules/pcrm/reports/feedback/purchaseAndFeedbackHistories"
            ),
          meta: {
            label: label.page.historyCustomer,
            requiresAuth: true,
          },
        },
      ],
    },
  ],
};

export default routeItems;
